export default __webpack_public_path__ + "static/media/bas_halftone.f887d16a.png";